import { useState } from "react";
import {
  Button,
  Grid,
  PanelModal,
  Radio,
  Text,
} from "@pushpress/shared-components";
import { formatCurrency } from "../../../../utils/currencyUtils";

interface UpdateSubscriptionsModalProps {
  visible: boolean;
  hasLimitCheckinsChanged: boolean;
  hasPriceChanged: boolean;
  hasSessionsCountChanged: boolean;
  planUuid: string;
  newLimitCheckins: boolean;
  newPrice: number;
  newSessionsCount?: number;
  newSessionsPeriod?: "billing-period" | "week" | "month";
  newPriorityBookingHours?: number;
  newPerPersonLimitNum?: number;
  activeSubscriptionsCount: number;
  onClose: VoidFunction;
  onConfirm: (update: {
    price: boolean;
    sessions: boolean;
  }) => void;
}

const booleanOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const UpdateSubscriptionsModal = (props: UpdateSubscriptionsModalProps) => {
  const { visible, onClose } = props;

  return (
    <PanelModal
      visible={visible}
      closeModal={onClose}
      width="400px"
      disableClickAway
      disableEscapeKeyDown
    >
      <AppointmentAccessContent {...props} />
    </PanelModal>
  );
};

const AppointmentAccessContent = (props: UpdateSubscriptionsModalProps) => {
  const {
    hasLimitCheckinsChanged,
    hasPriceChanged,
    hasSessionsCountChanged,
    newLimitCheckins,
    newPrice,
    newSessionsCount,
    newSessionsPeriod,
    activeSubscriptionsCount,
    onConfirm,
    onClose,
  } = props;

  const [updatePrice, setUpdatePrice] = useState(false);

  const [updateCheckins, setUpdateCheckins] = useState(false);

  const handleOk = () => {
    onConfirm({
      price: updatePrice,
      sessions: updateCheckins,
    });
    onClose();
  };

  let sessionsText = `${newSessionsCount} per ${newSessionsPeriod?.replace(
    "-",
    " ",
  )}`;
  if (hasLimitCheckinsChanged && !newLimitCheckins) {
    sessionsText = "unlimited";
  }

  return (
    <>
      <PanelModal.Body>
        <Text
          component="h2"
          color="wolf-800"
          variant="heading-4"
          className="mb-3"
        >
          {`Update ${activeSubscriptionsCount} active subscriptions?`}
        </Text>
        {hasPriceChanged && (
          <>
            <Text color="wolf-800" variant="body-lg" className="mb-4">
              {`Update to the new price of `}
              <b>{formatCurrency(newPrice)}</b>?
            </Text>
            <Radio
              selected={updatePrice}
              onSelect={setUpdatePrice}
              options={booleanOptions}
            />
          </>
        )}
        {(hasLimitCheckinsChanged || hasSessionsCountChanged) && (
          <>
            <Text
              color="wolf-800"
              variant="body-lg"
              className={`mb-4 ${hasPriceChanged ? "mt-4" : ""}`}
            >
              {`Update to the new check-in limit of `}
              <b>{sessionsText}</b>?
            </Text>
            <Radio
              selected={updateCheckins}
              onSelect={setUpdateCheckins}
              options={booleanOptions}
            />
          </>
        )}
        <Grid container justifyContent="flex-end" spacing={2} className="mt-3">
          <Grid item>
            <Button
              buttonType="secondary"
              text="Back"
              className="px-3"
              onClick={onClose}
            />
          </Grid>
          <Grid item>
            <Button
              buttonType="primary"
              text="OK"
              className="px-4"
              onClick={handleOk}
            />
          </Grid>
        </Grid>
      </PanelModal.Body>
    </>
  );
};

export default UpdateSubscriptionsModal;
